module.exports = __webpack_public_path__ + "static/media/Team 30 - Infinity.71218b65.png";